import { PaginatedDto } from "@core/data/dto/paginated.dto";
import { Type } from "class-transformer";
import {
    IsArray,
    IsDateString,
    IsNotEmpty,
    IsNumber,
    IsString,
} from "class-validator";

export class PublicUtilityDto {
    @IsNumber()
    @IsNotEmpty()
    id!: number;

    @IsString()
    @IsNotEmpty()
    organization_type!: string;

    @IsNumber()
    @IsNotEmpty()
    entity!: number;

    @IsDateString()
    @IsNotEmpty()
    date!: string;
}

export class PublicUtilitiesDto extends PaginatedDto {
    @IsArray()
    @Type(() => PublicUtilityDto)
    results!: PublicUtilityDto[];
}
